import { Button, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import AppTable from "components/AppTable/AppTable";
import { PDFViewer } from "components/PDFViewer/PDFViewer";
import { toDate } from "helpers/dateHelper";
import { useState } from "react";
import { MdDelete, MdOutlineArticle } from "react-icons/md";

interface IKnowledgeDocument {
  id: number;
  name: string;
  description: string;
  createdAt: string;
}

interface IKnowledgeDocumentListProps {
  data: IKnowledgeDocument[];
  handleDelete: (id: number) => void;
}

export const KnowledgeDocumentList = ({ data, handleDelete }: IKnowledgeDocumentListProps) => {
  const [open, setOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any | null>(null);

  const columnConfig = [
    {
      label: "ID",
      key: "id",
    },
    {
      label: "Название",
      key: "name",
    },
    {
      label: "Посмотреть документ",
      key: "view",
      render: (v: IKnowledgeDocument) => {
        return (
          <IconButton
            size="small"
            onClick={() => {
              setSelectedDocument(v);
              setOpen(true);
            }}
          >
            <MdOutlineArticle size={20} />
          </IconButton>
        );
      },
    },
    {
      label: "Дата создания",
      key: "createdAt",
      formatter: (v: string) => toDate(v),
    },
    {
      label: "Удалить",
      key: "delete",
      render: (v: IKnowledgeDocument) => {
        return (
          <IconButton size="small" onClick={() => handleDelete(v.id)}>
            <MdDelete size={20} />
          </IconButton>
        );
      },
    },
  ];

  const handleView = (id: number) => {
    console.log("id", id);
  };

  return (
    <div>
      <h3>Список загруженных документов</h3>
      {data && data.length > 0 ? (
        <AppTable data={data} columnConfig={columnConfig} />
      ) : (
        <div className="text-center">Нет загруженных документов</div>
      )}
      <Dialog
        fullWidth        
        maxWidth="lg"        
        open={open}
        onClose={() => {
          setOpen(false);
          setSelectedDocument(null);
        }}
      >
        <DialogTitle>Просмотр документа</DialogTitle>
        <DialogContent>
          <PDFViewer url={selectedDocument?.sourceURL} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
